import Alpine from 'alpinejs';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

Alpine.data('GalleryLightbox', () => ({
    init(){
        const lightbox = new PhotoSwipeLightbox({
            gallery: '#LightboxGallery',
            children: 'a',
            pswpModule: () => import('photoswipe')
            });
            lightbox.init();
    }
}));